/*eslint-disable */

import { bus } from '@/main';
import countries from '@/services/country.json';

export default {
  name: 'member-user-detail-popup',
  components: {},
  props: ['memUsrInfo'],
  data () {
    return {
      userInfo:null,
      userInfoExtraData:null,
      countryList:[],
      userCvData:null,
      cvButtonCheck:true
    }
  },
  computed: {

  },
  mounted () {
    this.userInfo = this.memUsrInfo
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.$store.dispatch('getMemberUserDetailsFun',{id:this.memUsrInfo.id}).then((res)=>{
      this.userInfoExtraData = res.data.data
    })
    this.$store.dispatch('getCVbyUserIdAction',{id:this.memUsrInfo.id}).then((res)=>{
      this.userCvData = res.data.data
      this.cvButtonCheck = true
    }).catch((err) => {
      this.userCvData = err.data
      this.cvButtonCheck = false
    })
  },
  methods: {
    closeMemInfoPopupMethod(keyword){
      bus.$emit('memUsrInfoPopupKeywordBus', keyword)
      bus.$emit('memUsrInfoPopupStateBus', false)
      document.body.classList.remove('notConnectedUserBody')
    },
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  }
}